import { ArrowUpRight, Car, Route, Plane } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { images } from "@/data/site";

const services = [
  {
    icon: Car,
    tag: "01",
    title: "Tesla-Verleih",
    text: "Aktuell im Verleih: Tesla Model 3 Long Range (Baujahr 02/2020). Ideal für die ausgiebige Probefahrt vor der Kaufentscheidung, eine besondere Ausfahrt oder das erste Elektro-Erlebnis.",
    image: images.fleet,
    wide: true,
  },
  {
    icon: Route,
    tag: "02",
    title: "Mobilitätsberatung",
    text: "Als IHK-zertifizierter betrieblicher Mobilitätsmanager (IHK Bremen) berate ich Sie ehrlich und praxisnah rund um Elektromobilität – für Privatpersonen und Unternehmen.",
  },
  {
    icon: Plane,
    tag: "03",
    title: "Vermittlung & Service",
    text: "Bei Interesse: Vermittlung von Langzeitmiete, Fahrzeugüberführungen und Flughafentransfer – einfach anfragen, wir finden die passende Lösung.",
  },
];

export const Services = () => {
  useReveal();
  return (
    <section id="leistungen" data-testid="services-section" className="py-24 md:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 reveal">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
              Leistungen
            </p>
            <h2 className="font-heading font-bold text-white tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight">
              Ein Auto. Echte Beratung. Klare Lösungen.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className={`reveal group relative overflow-hidden rounded-2xl border border-white/10 bg-card hover:border-white/25 hover:-translate-y-1 transition-all duration-300 ${
                s.wide ? "lg:col-span-3 lg:flex" : ""
              }`}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              {s.image && (
                <div className="lg:w-1/2 h-56 lg:h-auto overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
              )}
              <div className={`p-8 md:p-10 ${s.wide ? "lg:w-1/2 lg:flex lg:flex-col lg:justify-center" : ""}`}>
                <div className="flex items-center justify-between mb-6">
                  <div className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center group-hover:border-white/40 transition-colors">
                    <s.icon className="w-5 h-5 text-white" strokeWidth={1.5} />
                  </div>
                  <span className="font-heading text-4xl font-extrabold text-white/10">
                    {s.tag}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-xl md:text-2xl text-white mb-3">
                  {s.title}
                </h3>
                <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-xl">
                  {s.text}
                </p>
                <a
                  href="#kontakt"
                  data-testid={`service-link-${i}`}
                  className="mt-6 inline-flex items-center gap-1.5 text-sm text-white hover:gap-3 transition-all"
                >
                  Anfrage stellen <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
